import React, { useState } from "react";
import {
  Container,
  Grid,
  Button,
  makeStyles,
} from "@material-ui/core";

import DashboardView from "./dashboard-view";
import SmallQuantityDashboardPanel from "../small-quantity-ticket/small-quantity-dashboard-panel";
import HydrovacDashboardPanel from "../hydrovac-ticket/hydrovac-dashboard-panel";
import RubbleDashboardPanel from "../rubble-ticket/rubble-dashboard-panel";
import { StreamKey, Streams } from "../../utils/constants";

const useStyles = makeStyles((theme) => ({
  navContainer: {
    borderBottom: `2px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  navButton: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "1rem",
    width: "100%",
    padding: theme.spacing(1, 2),
    borderRadius: 6,
    color: theme.palette.text.secondary,
    backgroundColor: "transparent",
    transition: "background-color 150ms, color 150ms",
    "&:hover": {
      backgroundColor: "var(--stream-bg)",
      color: "var(--stream-color)",
    },
  },
  navButtonActive: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "1rem",
    width: "100%",
    padding: theme.spacing(1, 2),
    borderRadius: 6,
    backgroundColor: "var(--stream-bg)",
    color: "var(--stream-color)",
    transition: "background-color 150ms, color 150ms",
    "&:hover": {
      backgroundColor: "var(--stream-bg)",
    },
  },
}));

const ACTIVE_STREAM_KEY = "usm-active-stream";

const DashboardContainer = () => {
  const classes = useStyles();
  const [activeStream, setActiveStream] = useState<StreamKey>(
    () => (localStorage.getItem(ACTIVE_STREAM_KEY) as StreamKey) || "main"
  );

  const onStreamChange = (key: StreamKey) => {
    setActiveStream(key);
    localStorage.setItem(ACTIVE_STREAM_KEY, key);
  };

  return (
    <>
      <Container maxWidth="xl">
        <div className={classes.navContainer}>
          <Grid container spacing={1} alignItems="center">
            {Streams.map((stream, index) => {
              // Visual gap between offices (group 1: Main + Rubble, group 2: SQ + Hydrovac).
              const startsNewGroup =
                index > 0 && Streams[index - 1].group !== stream.group;
              return (
                <React.Fragment key={stream.key}>
                  {startsNewGroup && (
                    <Grid item xs={12} sm="auto">
                      <div style={{ width: 32 }} />
                    </Grid>
                  )}
                  <Grid item xs={6} sm="auto">
                    <Button
                      disableRipple
                      style={{
                        "--stream-bg": stream.bg,
                        "--stream-color": stream.color,
                      } as React.CSSProperties}
                      className={
                        activeStream === stream.key
                          ? classes.navButtonActive
                          : classes.navButton
                      }
                      onClick={() => onStreamChange(stream.key)}
                    >
                      {stream.label}
                    </Button>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </div>
      </Container>
      {activeStream === "main" && <DashboardView />}
      {activeStream === "small-quantity" && <SmallQuantityDashboardPanel />}
      {activeStream === "rubble" && <RubbleDashboardPanel />}
      {activeStream === "hydrovac" && <HydrovacDashboardPanel />}
    </>
  );
};

export default DashboardContainer;
